import { ModalWrapper } from "../../../../components/ui";
import { Alert } from "../../../../components/ui";
import { Button } from "../../../../components/ui";

/**
 * Confirm/cancel warning for Schedule actions that may alter Dispatch-edited scope data.
 *
 * @param {Object} props
 * @param {boolean} props.open
 * @param {() => void|Promise<void>} props.onConfirm
 * @param {() => void} props.onClose
 * @param {boolean} [props.deleteWarning=false]
 * @param {string} [props.title]
 * @param {string} [props.message]
 * @returns {JSX.Element}
 */
export default function ScheduleDispatchEditedWarningModal({
  open,
  onConfirm,
  onClose,
  deleteWarning = false,
  title,
  message,
}) {
  const modalTitle = title ?? (deleteWarning
    ? "Proceed with deleting Dispatch-edited data?"
    : "Proceed with changing Dispatch-edited data?");
  const warningMessage = message ?? (deleteWarning
    ? "The change you are making will delete data that was set in Dispatch."
    : "The change you are making will modify data that was set in Dispatch.");

  return (
    <ModalWrapper
      isOpen={open}
      onClose={onClose}
      closeButton={false}
      closeOnOutsideClick={false}
      maxWidth={460}
      overlayClassName="z-[10060]"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="schedule-dispatch-edited-warning-title"
      >
        <div className="px-4 py-3 pb-0">
          <h2
            id="schedule-dispatch-edited-warning-title"
            className="text-base font-semibold text-gray-900"
          >
            {modalTitle}
          </h2>
        </div>
        <div className="space-y-3 px-4 py-4 pb-0 text-sm text-gray-700">
          <Alert
            type={deleteWarning ? "strongWarning" : "warning"}
            message={warningMessage}
          />
          <p className="text-gray-800">
            Are you sure you want to continue?
          </p>
        </div>
        <div className="px-4 py-3">
          <div className="flex flex-wrap items-center justify-end gap-2 border-t border-gray-100">
            <Button
              variant="custom"
              className="border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-100"
              onClick={onClose}
              text="Cancel"
            />
            <Button
              variant="custom"
              className="bg-gray-900 px-3 py-1.5 text-sm font-medium text-white hover:bg-gray-800"
              onClick={() => void onConfirm()}
              text="Confirm"
            />
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
}
